import * as React from "react"
import { useTracker } from "@modules/analytics"
import { useToggleBuilds } from "../hooks/useToggleBuilds"
import { siteBuildsSettings as text } from "@modules/locales/default.js"
import { ToggleCheckbox } from "gatsby-interface"

export type EnableBuildsProps = {
  siteId: string
  buildsEnabled: boolean
}

export function EnableBuilds({ siteId, buildsEnabled }: EnableBuildsProps) {
  const [toggleBuilds, { errorAlert }] = useToggleBuilds(siteId)
  const { trackButtonClicked } = useTracker()

  return (
    <React.Fragment>
      <ToggleCheckbox
        id="enable-builds-checkbox"
        label={text.labels.enableBranchAndPullRequestBuilds}
        hint={text.messages.runsProductionAndPullRequestBuilds}
        checked={!!buildsEnabled}
        onChange={() => {
          trackButtonClicked(`update incremental builds`, {
            uiSource: `Site Settings`,
          })

          toggleBuilds()
        }}
      />
      {errorAlert}
    </React.Fragment>
  )
}
